module.exports = __webpack_public_path__ + "static/media/modernizacja-3.e65b5d98.JPG";